import { useState, type FormEvent } from 'react';

const FORM_ID = 'dahcfjrp14a1h3mr6ik0';
const SUBMIT_URL = 'https://readdy.ai/api/form/dahcfjrp14a1h3mr6ik0';

export default function NewsletterForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    const guard = String(data.get('contact_alt') ?? '').trim();
    if (guard) {
      setStatus('success');
      return;
    }

    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key === 'contact_alt') return;
      payload.append(key, String(value));
    });

    setStatus('loading');
    setFormError('');

    try {
      const response = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || parsed?.code || responseText || '提交失败';

      const isSpam = String(serverMsg).toLowerCase().includes('spam');
      if (!response.ok || parsed?.code !== 'OK' || isSpam) {
        setStatus('error');
        setFormError(
          isSpam ? '提交未通过校验，请稍后重试。' : `提交未成功：${serverMsg}`,
        );
        return;
      }

      setStatus('success');
      form.reset();
    } catch {
      setStatus('error');
      setFormError('网络异常，请稍后再试。');
    }
  };

  return (
    <form
      id={`newsletter-${FORM_ID}`}
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
    >
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <label htmlFor="newsletter-email" className="sr-only">
            邮箱地址
          </label>
          <input
            id="newsletter-email"
            name="email"
            type="email"
            required
            placeholder="留下邮箱，第一时间收到热议周报"
            className="w-full h-12 px-4 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
          />
        </div>
        <input
          className="form-guard-field"
          type="text"
          name="contact_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <button
          type="submit"
          disabled={status === 'loading'}
          className="h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
        >
          {status === 'loading' ? '提交中…' : '订阅周报'}
        </button>
      </div>
      {status === 'success' && (
        <p className="mt-3 text-sm text-secondary-700 flex items-center gap-1">
          <i className="ri-check-line"></i>订阅成功，热门讨论会定期送达你的邮箱。
        </p>
      )}
      {status === 'error' && (
        <p className="mt-3 text-sm text-primary-600 flex items-center gap-1">
          <i className="ri-error-warning-line"></i>
          {formError}
        </p>
      )}
    </form>
  );
}